import React from 'react'
import { useTranslation } from 'react-i18next'

import SectionComponent from '../../../../components/utils/SectionComponent'

import "./everyCent.scss"


function EveryCent() {

  const { t } = useTranslation()

  return (
    <div className='container-every-cent'>
      <div className="texts-every-cent">

        <SectionComponent title={t("industry.economy.title")} text={t("industry.economy.section_text_1")}>
          <p>{t("industry.economy.section_text_2")}</p>
        </SectionComponent>
      </div>
    </div>
  )
}

export default EveryCent